import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from 'src/app/services/alert/alert.service';
import { UsuarioService } from 'src/app/services/usuario.service';

@Component({
  selector: 'app-new-rol',
  templateUrl: './new-rol.component.html',
  styleUrls: ['./new-rol.component.css']
})
export class NewRolComponent implements OnInit {

  form: FormGroup = new FormGroup({});

  constructor(
    public dialogRef: MatDialogRef<NewRolComponent>, 
    @Inject(MAT_DIALOG_DATA) public data:any, 
    private formBuilder: FormBuilder, 
    private usuarioService: UsuarioService,
    private alert: AlertService
  ) { }

  ngOnInit(): void {
    this.cargarFormulario();
    if (this.data) {
      this.cargarDatos();
    }
  }

  cargarDatos() {
    this.form.reset({
      nombre: this.data.name
    });
  }

  cargarFormulario() {
    this.form = this.formBuilder.group({
      nombre: ['', [Validators.required]]
    });
  }

  guardar() {
    if (this.form.invalid) {
      this.alert.showInfo("invalid");
      return;
    }

    const formData = new FormData();
    formData.append('name', this.form.value.nombre);

    this.usuarioService.postRol(formData)
      .subscribe((res: any) => {
        if (res.data.status !== 200) {
          this.alert.showErrorCustom(res.data.mensaje);
          return;
        }
        else {
          this.alert.showSave('ok');
          this.dialogRef.close(true);
        }
      },
      (err: any) => {
        this.alert.showSave('error');
      });
  }

  actualizar() {
    let datos = {
      name: this.form.value.nombre
    };
    this.usuarioService.putRol(this.data.id, datos)
      .subscribe((res: any) => {
        if (res.data.status !== 200) {
          this.alert.showErrorCustom(res.data.mensaje);
          return;
        }
        this.alert.showUpdate("ok");
        this.dialogRef.close(true);
      },
      (err: any) => {
        this.alert.showUpdate("error");
      });
  }

}
